import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './UserChip.scss';

class UserChip extends Component {
  render() {
    const { user, extraText } = this.props;
    if (!user) return null;
    const { picture, name, uid } = user;
    return (
      <Link to={`/profile/${uid}/shoutouts`} className="user-chip">
        <img src={picture} alt={name} />
        {name}{extraText}
      </Link>
    );
  }
}

export { UserChip };



// WEBPACK FOOTER //
// ./src/components/UserChip.js